import useZendeskVisibility from '@/hofs/useZendeskVisibility'

interface ZendeskWrapperProps {
  children: React.ReactNode
}

const ZendeskWrapper = ({ children }: ZendeskWrapperProps) => {
  useZendeskVisibility()

  return <>{children}</>
}

export default ZendeskWrapper
